module.exports = __webpack_public_path__ + "static/media/S6.1af135fd.webp";